import { CustomAction } from './customAction';
import { BaseModel } from '../models/basemodel';

export class CustomTableAction<T extends BaseModel> extends CustomAction<T> {
  public icon?: string;

  constructor(text: string, icon = '') {
    super(text, false);
    this.icon = icon;
  }
}
